import EntityTab from "./EntityTab";

export default EntityTab;
